import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AGStripeModalComponent } from './ag-stripe-modal.component';
import { DxLoadPanelModule } from 'devextreme-angular';
import { ButtonWithIndicatorModule, ModalWindowModule } from '..';
import { CloudFunctionsService } from '../../services/cloud-functions.service';
import { StripeElementsDirective, StripePaymentElementComponent } from 'ngx-stripe';

@NgModule({
  declarations: [AGStripeModalComponent],
  imports: [
    CommonModule,
    StripeElementsDirective,
    StripePaymentElementComponent,
    ButtonWithIndicatorModule,
    ModalWindowModule,
    DxLoadPanelModule,
  ],
  providers: [CloudFunctionsService],
  exports: [AGStripeModalComponent],
})
export class AgStripeFormModule {}
